import { defineStore } from 'pinia'

// 第一个参数是应用程序中 store 的唯一 id
export const homePage = defineStore('homePage', {
  state: () => {
    return {
      medicalRecordInformation: null, // 首页配置好的病历信息-用于跳转到AI对话时传参用
      chatKey: null, // 有聊天记录的AIkey 
      addResultParams: null, // 新增病历模板结果所需要的参数 
      
    }
  },
  getters: {},
  actions: {
    setMedicalRecordInformation(data) {
      this.medicalRecordInformation = data
    },
    setChatkey(data) {
      this.chatKey = data
    },
    setAddResultParams(data) {
      this.addResultParams = data
    }
  },
  persist: {
    enabled: true,
  }
})
